export default {
    user: {},
    baseUrl: '/api',
    subdomain: '',
    systemStatus: {},
    activities: {},
    assetCategories: {},
    assetStatuses: {},
    businessHourContracts: {},
    categories: {},
    configs: {},
    countries: {},
    operators: {},
    contractPeriods: {},
    customFields: {},
    invoiceStatuses: {
        1: { name: 'invoice.status.sent', style: 'light' },
        2: { name: 'invoice.status.outstanding', style: 'danger' },
        3: { name: 'invoice.status.outstanding', style: 'danger' },
        4: { name: 'invoice.status.paid', style: 'success' },
        8: { name: 'invoice.status.credit-invoice', style: 'light' },
        9: { name: 'invoice.status.expired', style: 'light' },
        99: { name: 'invoice.status.unknown', style: 'light' },
    },
    operatorTypes: {},
    permissions: {},
    prepaidCards: {},
    priorities: {},
    products: {},
    quoteStatuses: {
        1: { id: 1, name: 'quotestatus.filter.concept', style: 'light' },
        2: { id: 2, name: 'quotestatus.filter.sent', style: 'primary' },
        3: { id: 3, name: 'quotestatus.filter.accepted', style: 'success' },
        4: { id: 4, name: 'quotestatus.filter.rejected', style: 'danger' },
    },
    ticketGroups: {},
    rolesOperator: {},
    rolesClient: {},
    services: {},
    slas: {},
    ticketStatuses: {},
    subscriptionPeriods: {},
    ticketSources: {},
    ticketTypes: {},
    tablePresets: {},
    usedProductInvoiceMoments: {
        1: { id: 1, name: 'usedproduct.invoice.moment.quote-accepted', style: 'light' },
        2: { id: 2, name: 'usedproduct.invoice.moment.start-phase', style: 'light' },
        3: { id: 3, name: 'usedproduct.invoice.moment.end-phase', style: 'light' },
    },
    usedProductInvoiceTypes: {
        1: { id: 1, name: 'usedproduct.invoice.type.product', style: 'light' },
        2: { id: 2, name: 'usedproduct.invoice.type.fixed-price', style: 'light' },
        3: { id: 3, name: 'usedproduct.invoice.type.calculation', style: 'light' },
    },
};
